module.exports = __webpack_public_path__ + "img/deny.9971ab46.svg";